import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Intimate.pt';
const DEFAULT_DESCRIPTION = 'Plataforma de leitura erótica para adultos. Contos, séries e muito mais.';
const API_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_OG_IMAGE = `${API_URL}/og-image.png`;

export default function SEOHead({ 
  title, 
  description, 
  image, 
  url, 
  type = 'article',
  jsonLd
}) {
  const fullTitle = title ? `${title} - ${SITE_NAME}` : `${SITE_NAME} - Contos Eróticos para Adultos`;
  const desc = description || DEFAULT_DESCRIPTION;
  const canonical = window.location.origin + window.location.pathname;
  const pageUrl = url || canonical;
  const ogImage = image ? (image.startsWith('/') ? window.location.origin + image : image) : DEFAULT_OG_IMAGE;

  // Drop the static index.html defaults so crawlers only see this page's tags.
  useEffect(() => {
    document.querySelectorAll('meta[data-default-meta]').forEach((m) => m.remove());
  }, []);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:locale" content="pt_PT" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd).replace(/</g, '\\u003c')}
        </script>
      )}
    </Helmet>
  );
}
